module.exports = __webpack_public_path__ + "img/SortingVisualizer.257106ad.png";